import type { Nullable } from "../../../../typescript"
import eightDirectionCharsLowerCase from "../../direction/eightDirectionCharsLowerCase"
import type { EntityTypeId } from "../../entity/EntityTypeId.enum"
import type { TileGraphNode } from "./TileGraphNode.type"

export default function getEightTilePositionNeighborsL1EntityTypeIdList(
  node: TileGraphNode,
): Array<Nullable<EntityTypeId>> {
  return eightDirectionCharsLowerCase.map(dir => node[dir]?.ents.l1.etype_id())
}